<style>
@font-face {
  font-family: Axiforma-Medium;
  src: url("../assets/font/Axiforma-Medium.ttf");
}

body {
  font-family: Axiforma-Medium !important;
}

* {
  font-family: Axiforma-Medium !important;
}

.v-treeview-node__children {
  font-size: 14px;
  font-weight: 100;
}

.v-treeview-node__root {
  display: inline-flex !important;
  align-items: center;
  min-height: 48px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  position: relative;
  width: 100%;
}

.v-icon.v-icon.v-icon--link {
  cursor: pointer;
  outline: none;
}

.link-design {
  font-weight: 450;
  color: #333 !important;
  text-decoration: none;
}

.link-head-design {
  text-decoration: none;
  color: #333 !important;
}

#inspire {
  background: #f2f2f2 !important;
}

.side-bar-cus {
  background: #f2f2f2 !important;
}

.v-list-item__content {
  padding: 8px 0 !important;
}

.v-text-field input {
  font-size: 1.2em;
  font-size: inherit;
}

.v-text-field--filled {
  background-color: white !important;
}

.custom_bgColor {
  background-color: white;
}

label {
  font-size: 18px !important;
  font-weight: bold;
  color: black;
  line-height: 3.1;
  font-size: 17px;
  font-weight: 400;
}

.v-menu__content {
  min-width: 141px !important;
}


#style-1 .v-navigation-drawer__content::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

#style-1 .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: #4e4d4c;
  background-image: -webkit-linear-gradient(90deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

#style-1 .v-navigation-drawer__content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.pi {
  font-family: "primeicons" !important;
}
</style>
<style scoped>
html {
  min-height: calc(100% + env(safe-area-inset-top));
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}

.nowordTablEwrap {
  white-space: nowrap !important;
}

.myboardpage_none-background {
  background: #050c44 !important;
}

.compliance-background {
  background: #050c44 !important;
}
</style>

<template>
  <v-app id="inspire">
    <v-overlay :value="overlay_load" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer app permanent :key="drawer" :mini-variant="!drawer" fixed clipped
      class="drawer-style overflow-hidden" id="style-1" :class="listBackgroundClass"
      v-if="iflag == 0 && logged_user_Email != null && show_hide_mob_btn == 1 && domain !== 'partner'" v-show="this.$route.name == 'survey_answer_customer_result' ? false : true
        ">
      <v-divider></v-divider>
      <v-list dense :dark="hostname.includes('myboardpage_none') ? false : true" :class="listBackgroundClass">
        <span v-for="item in items" :key="item.id">
          <v-list-group v-if="item.has_children && checkproductvalue(item)" :prepend-icon="item.icon" no-action
            :color="getDomainColor()" @click="
              (item.name == 'Team', 'Score') ? router_pusher(item.to) : ''
              "
          >
            <!-- masters here -->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.name" class="xyz x-1"></v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-for="child in item.children" :key="child.key" v-if="checkproductvalue(child)">
              <v-list-item :to="child.to" :title="child.name" v-if="!child.sub_children" class="pl-10">
                <v-list-item-icon>
                  <v-icon v-text="child.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.name" class="xyz x-2"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group v-if="child.sub_children || child.has_children" no-action sub-group
                :color="getDomainColor()">
                <!-- under masters -->
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="child.name" class="xyz x-3"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="subchild in child.children" :key="subchild.id" :to="subchild.to"
                  :title="subchild.name" v-if="
                    !child.has_grand_children && checkproductvalue(subchild)
                  " class="pl-10">
                  <v-list-item-icon>
                    <v-icon v-text="subchild.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="subchild.name" class="xyz x-4"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- fms masters -->
                <v-list-item v-for="subchild in child.children" :key="subchild.id" :to="subchild.to"
                  :title="subchild.name" v-if="child.has_grand_children && checkproductvalue(subchild)" class="pl-5">
                  <v-list-group no-action sub-group :color="getDomainColor()">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title v-text="subchild.name" class="xyz krishna"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item-content>
                      <v-list-item v-for="grouping_children in subchild.children" :key="grouping_children.id"
                        :to="grouping_children.to" :title="grouping_children.name"
                        v-if="checkproductvalue(grouping_children)" class="pl-5">
                        <v-list-item-icon>
                          <v-icon v-text="grouping_children.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title v-text="grouping_children.name" class="xyz vbm"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-content>
                  </v-list-group>
                </v-list-item>
              </v-list-group>
            </span>

            <!-- sub_children -->
          </v-list-group>
          <v-list-item 
            :to="item.to" 
            :title="item.name" 
            v-if="
              !item.has_children &&
              checkproductvalue(item) &&
              !item.onlytextviews
            " 
            :color="getDomainColor()"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="xyz x-5"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-subheader inset v-if="item.onlytextviews && checkproductvalue(item)"
            style="font-size: 14px; font-weight: bold">
            {{ user_name }}'s Space
          </v-subheader>
          <v-divider v-if="item.underline && checkproductvalue(item)" color="#fff"></v-divider>
        </span>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer 
      app permanent :key="drawer" 
      :expand-on-hover="!drawer" fixed clipped 
      class="drawer-style"
      id="style-1" 
      style="background: #050c44 !important; color: #fff" 
      v-if="iflag == 1 && show_hide_mob_btn == 2 && domain !== 'partner'"
    >
      <v-divider></v-divider>
      <v-list dense :class="listBackgroundClass">
        <span v-for="item in items" :key="item.id">
          <v-list-group 
            v-if="item.has_children && checkproductvalue(item)" :prepend-icon="item.icon" no-action
            :color="getDomainColor()" 
            @click="
              (item.name == 'Team', 'Score') ? router_pusher(item.to) : ''
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.name" class="xyz x-6"></v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-for="child in item.children" :key="child.key" v-if="checkproductvalue(child)">
              <v-list-item :to="child.to" :title="child.name" v-if="!child.sub_children" class="pl-10">
                <v-list-item-icon>
                  <v-icon v-text="child.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.name" class="xyz x-7"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-group v-if="child.sub_children" no-action sub-group :color="getDomainColor()">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="child.name" class="xyz x-8"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="subchild in child.children" :key="subchild.id" :to="subchild.to"
                  :title="subchild.name" v-if="checkproductvalue(subchild)" class="pl-10">
                  <v-list-item-icon>
                    <v-icon v-text="subchild.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="subchild.name" class="xyz x-9"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </span>
            <!-- sub_children -->
          </v-list-group>
          <v-list-item :to="item.to" :title="item.name" v-if="
            !item.has_children &&
            checkproductvalue(item) &&
            !item.onlytextviews
          " :color="getDomainColor()">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="xyz x-10"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-subheader inset v-if="item.onlytextviews && checkproductvalue(item)"
            style="font-size: 14px; font-weight: bold">{{ user_name }}'s Space</v-subheader>
          <v-divider v-if="item.underline && checkproductvalue(item)" color="#fff"></v-divider>
        </span>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer 
      v-model="drawer" 
      app 
      class="side-bar-cus" 
      prominent 
      style="
        background: #050c44 !important;
        color: #fff;
        top: 57px;
        z-index: 50;
      " 
      v-if="show_hide_mob_btn == 2 && domain !== 'partner'"
    >
      <v-list-item style="background: #050c44">
        <v-list-item-content>
          <v-list-item-title class="title" style="text-align: center">
            <img src="../assets/MS-LOGO-1-blue.png" width="130px" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense :class="listBackgroundClass">
        <span v-for="item in items" :key="item.id">
          <v-list-group v-if="item.has_children && checkproductvalue(item)" :prepend-icon="item.icon" no-action
            :color="getDomainColor()">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.name" class="xyz x-11"></v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-for="child in item.children" :key="child.id" v-if="checkproductvalue(child)">
              <v-list-item :to="child.to" :title="child.name" v-if="!child.sub_children" class="pl-10">
                <v-list-item-icon>
                  <v-icon v-text="child.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.name" class="xyz x-12"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group v-if="child.sub_children" no-action sub-group :color="getDomainColor()">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="child.name" class="xyz x-13"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="subchild in child.children" :key="subchild.id" :to="subchild.to"
                  :title="subchild.name" v-if="
                    !child.has_grand_children && checkproductvalue(subchild)
                  " class="pl-10">
                  <v-list-item-icon>
                    <v-icon v-text="subchild.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="subchild.name" class="xyz x-14"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- fms masters -->
                <v-list-item v-for="subchild in child.children" :key="subchild.id" :to="subchild.to"
                  :title="subchild.name" v-if="child.has_grand_children && checkproductvalue(subchild)" class="pl-10">
                  <v-list-group no-action sub-group :color="getDomainColor()">
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title v-text="subchild.name" class="xyz krishna"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item-content>
                      <v-list-item v-for="grouping_children in subchild.children" :key="grouping_children.id"
                        :to="grouping_children.to" :title="grouping_children.name"
                        v-if="checkproductvalue(grouping_children)" class="pl-10">
                        <v-list-item-icon>
                          <v-icon v-text="grouping_children.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title v-text="grouping_children.name" class="xyz vbm"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-content>
                  </v-list-group>
                </v-list-item>
              </v-list-group>
            </span>
          </v-list-group>
          <v-list-item :to="item.to" :title="item.name" v-if="
            !item.has_children &&
            checkproductvalue(item) &&
            !item.onlytextviews
          " :color="getDomainColor()">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.name" class="xyz x-15"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-subheader inset v-if="item.onlytextviews && checkproductvalue(item)"
            style="font-size: 14px; font-weight: bold">{{ user_name }}'s Space</v-subheader>
          <v-divider v-if="item.underline && checkproductvalue(item)" color="#fff"></v-divider>
        </span>
      </v-list>
    </v-navigation-drawer>
    <!-- desktop_view -->
    <div v-if="iflag == 1">
      <v-app-bar class="main_app_bar_style" app elevation="1" height="62" color="white" flat
        style="left: 0;padding:0px !important" fixed elevate-on-scroll scroll-target="#scrolling-techniques-7">
        <div class="align-center d-flex" v-if="iflag == 0">
          <img src="@/assets/logo_without_background.png" width="35px" height="35px" class="pa-0" style="object-fit:contain" v-if="!drawer" />
          <img src="@/assets/starr_logo_menu_2.png" width="130px" height="40px" class="pa-0" style="object-fit:contain" v-if="drawer" />
        </div>
        <div style="flex-grow: 0.03 !important" v-if="iflag == 0"></div>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <b>{{ entity_name }}</b>
        <v-spacer></v-spacer>
        <div v-if="domain != 'admin'" class="float-right">
          <v-icon class="mr-3" size="25" v-if="
            JSON.parse(entityData) ? JSON.parse(entityData).length > 1 : false
          " color="black" @click="switch_entity" title="Switch Company">mdi-swap-horizontal</v-icon>
          <v-spacer></v-spacer>
        </div>
        <b>{{ user_name }}</b>&nbsp;&nbsp;
        <v-icon class="ml-3" size="25" color="black" @click="logout()">mdi-power-settings</v-icon>
      </v-app-bar>

    </div>
    <div v-if="iflag == 0">
      <v-app-bar app clipped-left class="elevation-2" v-if="logged_user_Email != null">
        <div class="align-center d-flex" v-if="iflag == 0">
          <img v-if="isComplianceDomain && !drawer" src="@/assets/logo_without_background.png" width="35px"
            height="35px" class="pa-0" style="object-fit:contain" />
          <img v-if="isComplianceDomain && drawer" src="@/assets/starr_logo_menu_2.png" width="130px" height="40px"
            class="pa-0" style="object-fit:contain" />

        </div>
        <div style="flex-grow: 0.03 !important" v-if="iflag == 0"></div>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>


        <b>{{ entity_name }}</b>

        <v-spacer></v-spacer>
        <div class="text-center">
          <v-btn rounded color="red" class="mr-3" @click="refresh_token()" v-if="badge_flag == true">
            <v-icon size="25">mdi-refresh</v-icon>

          </v-btn>
          <v-dialog persistent v-model="dialog" width="700">
            <template v-slot:activator="{ on, attrs }">
              <v-btn style="margin-right: 6px" rounded v-bind="attrs" v-on="on">
                <v-icon size="25">mdi-plus</v-icon>
                <h4 style="padding-top: 3px">New</h4>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">Quick Add</v-card-title>

              <v-row no-gutters>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_EMPLOYEE', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="add_employee()">
                    Add Employee
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_SERVICE', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="addService()">
                    Add Service
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px"
                  v-if="screen_auth('SCN_CHCK_MY_CHECKLIST', 'add_screen')">
                  <v-btn class="ma-1" @click="mainchecklist()" color="black" plain>
                    ADD Checklist
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px"
                  v-if="screen_auth('SCN_PMS', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="addkpi('add')" plain>
                    ADD Kpi
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_VISITS', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="logvisit()" plain>
                    Plan Visit
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_VISITS', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="planvisit()" plain>
                    Log Visit
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_TKT_TICKETS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="close_ticket()">
                    ADD Ticket
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_WALKINS', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="addwalkins()"
                    :disabled="branch_ID == 'null' || branch_ID == '0'" plain>
                    ADD Walkin
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_PLANNING', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="addgoals()" plain>
                    ADD Goal
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_SURVEY', 'add_screen')">
                  <v-btn class="ma-1" color="black" @click="addsurvey()" plain>
                    ADD Survey
                  </v-btn>
                </v-col>

                <v-col v-if="this.branch_ID == 'null' || this.branch_ID == '0'">
                  <div class="mx-5">
                    <v-alert dense outlined type="error">
                      To add a walkin - please
                      <strong>map a branch</strong> to the user & re-login
                    </v-alert>
                  </div>
                </v-col>
              </v-row>

              <template v-if="!isHealthcheckUser">
              <v-divider></v-divider>

              <v-card-title style="margin-top: 2%" class="text-h5 lighten-2">
                My Zone
              </v-card-title>

              <v-row no-gutters>
                <v-col cols="12" md="4" style="padding-top: 0px"
                  v-if="screen_auth('SCN_CHCK_MY_CHECKLIST', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="open_checklist()">
                    My Checklists
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_TKT_TICKETS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="open_ticket()">
                    My Tickets
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_SURVEY', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="open_survey()">
                    My Surveys
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_WALKINS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="open_walkins()">
                    My Walkins
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_VISITS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="open_visit()">
                    My Visits
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_CHCK_REPORTS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="checklist_report()">
                    Checklists Report
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_TKT_REPORTS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="ticket_report()">
                    Tickets Report
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_WLK_RPRT', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="walkins_report()">
                    Walkins Report
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_VISIT_REPORTS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="visit_report()">
                    Visits Report
                  </v-btn>
                </v-col>

                <v-col cols="12" md="4" style="padding-top: 0px" v-if="screen_auth('SCN_SURVEY_REPORTS', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="survey_report()">
                    Survey Report
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4" style="padding-top: 0px"
                  v-if="screen_auth('SCN_INCENTIVE_POLICY', 'add_screen')">
                  <v-btn class="ma-1" color="black" plain @click="incentive_report()">
                    Incentives Report
                  </v-btn>
                </v-col>
              </v-row>
              </template>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div v-if="domain != 'admin'" class="float-right">
          <v-icon class="mr-3" size="25" v-if="
            JSON.parse(entityData) ? JSON.parse(entityData).length > 1 : false
          " color="black" @click="switch_entity" title="Switch Company">mdi-swap-horizontal</v-icon>
          <v-spacer></v-spacer>
        </div>
        <!-- Release Notes bell — shows unread badge, opens history drawer (non-admin only) -->
        <ReleaseNotesDrawer v-if="!['admin','devadmin'].includes(domain)" class="mr-2" />

        <b style="margin-right: 4%">{{ user_name }}</b>&nbsp;&nbsp;

        <template>
          <div>
            <v-menu offset-y style="z-index: 15">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar icon v-bind="attrs" v-on="on" color="#90A4AE" size="53"
                  style="position: absolute; top: 4px; right: 13px"><v-icon>mdi-account</v-icon>
                </v-avatar>
              </template>
              <v-card>
                <v-list>
                  <v-list-item @click="UpdateProfile">
                    <v-list-item-title class="xyz x-16">
                      <v-icon size="23">mdi-account-details </v-icon> My
                      Profile</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="logout()">
                    <v-list-item-title class="xyz x-17"><v-icon size="23">mdi-logout</v-icon>
                      Logout</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </template>
      </v-app-bar>
    </div>
    <v-dialog v-model="switch_dialog" persistent scrollable width="600px">
      <v-card>
        <v-card-title>Switch Company</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-radio-group v-model="entity_id" column>
            <v-radio @change="getentityname(entity.name)" v-for="(entity, index) in entity_dataset" :value="entity.id"
              :label="entity.name" :key="index"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn color="blue darken-1" v-if="entity_ID" text @click="entity_ID ? (switch_dialog = false) : ''">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" text @click="login()"> Save </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- mobile_view -->
    <v-app-bar 
      app clipped-left class="elevation-2" 
      v-if="logged_user_Email != null && show_hide_mob_btn == 2"
      style="background: rgb(5 12 69) !important; height: 67px; position: fixed"
    >
      <div style="flex-grow: 0.03 !important" v-if="iflag == 0"></div>
      <v-app-bar-nav-icon style="color: white; top: 2px; left: -20px" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <b 
        style="
          color: white;
          margin-left: -28px;
          margin-top: 9px;
          font-size: 20px;
        " 
        class="d-flex justify-content-center"
      >
      {{ entity_name }}
      <img 
        src="../assets/tectalik_small_transparent1.png" 
        width="35px" height="30px" class="pa-0" 
        style="
          margin-left: -57px;
          margin-top: -2px;
          opacity: 0.2;
          blend: lighten;
        "
        v-if="!drawer" 
      /></b>
      <v-btn small fab width="43px" height="40px" style="margin-left: 40px; margin-top: 2px" color="#FFF59D"
        v-if="badge_flag == true && !drawer" @click="refresh_token()">
        <v-icon size="25">mdi-refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="domain != 'admin'" class="float-right">
        <v-icon class="mr-1" style="top: 2px; left: -46px" size="25" v-if="
          JSON.parse(entityData) ? JSON.parse(entityData).length > 1 : false
        " color="white" @click="switch_entity" title="Switch Company">mdi-swap-horizontal</v-icon>
        <v-spacer></v-spacer>
        <div v-if="show_hide_mob_btn == 2">
          <v-menu offset-y style="z-index: 15">
            <template v-slot:activator="{ on, attrs }">
              <v-avatar icon v-bind="attrs" v-on="on" color="#FFF59D" size="53" style="
                  align-items: baseline;
                  height: 40px;
                  min-width: 43px;
                  width: 43px;
                  position: absolute;
                  top: 9px;
                  right: 6%;
                "><v-icon>mdi-account</v-icon>
              </v-avatar>
            </template>
            <v-list>
              <v-list-item @click="UpdateProfile">
                <v-list-item-title class="xyz x-18">
                  <v-icon size="23">mdi-account-details </v-icon> My
                  Profile</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-title class="xyz x-19"><v-icon size="23">mdi-logout</v-icon>
                  Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>&nbsp;&nbsp;
    </v-app-bar>
    <v-dialog transition="dialog-bottom-transition" v-if="show_hide_mob_btn == 2" v-model="switch_dialog" fullscreen
      persistent width="600px">
      <v-card style="position: fixed">
        <div>
          <div style="background: rgb(5 12 69) !important">
            <img src="../assets/company.png" width="100%" height="250vh" style="opacity: 40%; mix-blend-mode: lighten"
              class="pa-0" />
            <div>
              <v-icon color="white" style="position: absolute; top: 22px; right: 23px" v-if="entity_ID"
                @click="entity_ID ? (switch_dialog = false) : ''">mdi-close</v-icon>
            </div>
          </div>
          <div>
            <v-col style="
                overflow: visible;
                margin-top: -41px;
                background: #ffffff;
                border-radius: 40px 40px 0px 0px;
              ">
              <h3 style="margin-left: 10px; margin-top: 30px">
                Hey <b>{{ user_name }}</b>&nbsp;&nbsp;
              </h3>
            </v-col>
            <v-card-title style="margin-top: -24px; margin-left: 6px">Select Company</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 237px; margin-left: 22px">
              <v-radio-group v-model="entity_id" column style="margin-right: 63px">
                <v-radio @change="getentityname(entity.name)" v-for="(entity, index) in entity_dataset"
                  :value="entity.id" :label="entity.name" :key="index"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-btn rounded style="
                width: 295px;
                top: 17px;
                background: rgb(5, 12, 69) !important;
                color: white;
                margin-left: 40px;
                height: 47px;
                text-transform: none;
                font-size: 20px;
              " text @click="login()">
              Continue
            </v-btn>
          </div>
          <v-card-actions>
            <v-col class="text-right"></v-col>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
    <v-main id="scrolling-techniques-7" class="custom_bgColor">
      <router-view :key="$route.path"></router-view>
    </v-main>
    <template>
      <v-bottom-navigation :value="value" color="rgb(5, 12, 68) !important" style="
          overflow: hidden;

          position: fixed;
          bottom: 0;
          justify-content: start;
          z-index: 10;
          overflow-x: scroll;
          height: 63px;
        " v-if="show_hide_mob_btn == 2">
        <v-btn>
          <span style="color: rgb(0, 1, 79)" @click="backups()">Home</span>
          <img src="../assets/tectalik_small_transparent1.png" width="30px" height="25px" class="pa-0"
            style="color: rgb(0, 1, 79)" v-if="!drawer" />
        </v-btn>

        <v-btn style="margin-left: -6%" v-if="checkFMS" @click="backupstick()">
          <span style="color: rgb(0, 1, 79)">FMS</span>

          <img src="../assets/FMSicon2.png" width="30px" height="25px" class="pa-0" style="color: rgb(0, 1, 79)"
            v-if="!drawer" />
        </v-btn>
        <v-btn @click="backups5()" style="margin-left: -3%">
          <span style="color: rgb(0, 1, 79)">Strategy</span>
          <v-icon style="color: rgb(0, 1, 79)">mdi-alpha-s-circle</v-icon>
        </v-btn>
        <v-btn @click="backups1()" style="margin-left: -3%">
          <span style="color: rgb(0, 1, 79)">Team</span>
          <v-icon style="color: rgb(0, 1, 79)">mdi-alpha-t-circle</v-icon>
        </v-btn>
        <v-btn @click="backups2()" style="margin-left: -5%" v-if="!isHealthcheckUser">
          <span style="color: rgb(0, 1, 79)">Act</span>
          <v-icon style="color: rgb(0, 1, 79)">mdi-alpha-a-circle</v-icon>
        </v-btn>
        <v-btn @click="backups4()" style="margin-left: -5%">
          <span style="color: rgb(0, 1, 79)">Review</span>
          <v-icon style="color: rgb(0, 1, 79)">mdi-alpha-r-circle</v-icon>
        </v-btn>
        <v-btn @click="backups3()" style="margin-left: -5%">
          <span style="color: rgb(0, 1, 79)">Reward</span>
          <v-icon style="color: rgb(0, 1, 79)">mdi-alpha-r-circle</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </template>
  </v-app>
</template>

<script>
import menu_list from "./menu_list.js";
import menu_list_boardpage from "./menu_list_boardpage.js";
import axios from "axios";
import Package from "/package.json";
import ReleaseNotesDrawer from "./ReleaseNotesDrawer.vue";
import moment from "moment";
import { invalidateTokenOnLogout } from "@/services/loginHelper.js";
export default {
  components: { ReleaseNotesDrawer },
  mounted: function () {
    // ── Partner mode: hide sidebar and lock to partner dashboard ──────────
    if (this.domain === 'partner') {
      if (this.$route.name !== 'partner-dashboard' && this.$route.name !== 'partner_dashboard') {
        this.$router.replace({ name: 'partner-dashboard' });
      }
      return;  // skip all the entity / menu setup below — not needed for partners
    }
    // ─────────────────────────────────────────────────────────────────────

    this.app_version();
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    let is_boardpage = false;
    if (hostname.includes('myboardpage_none') || pathname.includes('myboardpage_none')) {
      this.items = menu_list_boardpage;
    } else {
      this.items = menu_list;
    }
    this.username = localStorage.getItem("USER_NAME");
    this.entity_name = localStorage.getItem("entity_name");
    this.entity_id = parseInt(localStorage.getItem("ENTITY_ID"));
    this.entity_ID = parseInt(localStorage.getItem("ENTITY_ID"));

    this.entity_id_list = localStorage.getItem("USER_ENTITY_DATASET");
    this.entityData = localStorage.getItem("entitydata");
    if (hostname.includes('myboardpage_none')) {
      is_boardpage = true;
    } else {
      is_boardpage = false;
    }
    localStorage.setItem('is_boardpage', is_boardpage.toString());

    if (!["admin", "devadmin"].includes(this.domain)) {
      if (
        !this.entity_ID &&
        (JSON.parse(this.entityData)
          ? JSON.parse(this.entityData).length > 1
          : false)
      ) {
        this.switch_entity();
      } else if (this.entityData && JSON.parse(this.entityData).length === 1) {
        let enty = JSON.parse(this.entityData);
        localStorage.setItem("ENTITY_ID", enty[0].id);
        localStorage.setItem("entity_name", enty[0].name);
        this.entity_ID = localStorage.getItem("ENTITY_ID");
      }
    }
    this.expiry_date = localStorage.getItem("expiry_date");
    this.current_date = moment().format("YYYY-MM-DD");
    this.diff_date = moment(this.expiry_date).diff(this.current_date, "days");
    if (this.diff_date < 3) {
      this.badge_flag = true;
    }
  },
  data: () => ({
    applicationVersion: Package.version,
    resultat: localStorage.getItem("resultat"),
    menu: false,
    checkFMS: localStorage.hasOwnProperty("tectalik_product_list")
      ? localStorage.getItem("tectalik_product_list").includes("TECTALIK_FMS")
      : false,
    overlay_load: false,
    url_break: [],
    entity_name: null,
    entity_id: null,
    entity_dataset: null,
    survey_walkin: false,
    domain: localStorage.getItem("domain"),
    switch_dialog: false,
    entity_ID: null,
    entityData: null,
    entity_dataset: [],
    user: true,
    getuser: [],
    device_token: null,
    user_name: localStorage.getItem("USER_NAME"),
    user_id: localStorage.getItem("USER_ID"),
    branch_ID: localStorage.getItem("BRANCH_ID"),
    drawer: false,
    items: [],
    mini: false,
    dialog: false,
    value: false,
    showimage: false,
    show_hide_mob_btn: 0,
    full_or_modal: 0,
    window: {
      width: 0,
      height: 0,
    },
    iflag: 0,
    logged_user_Email: localStorage.getItem("USER_EMAIL"),
    old_token: localStorage.getItem("TOKEN"),
    expiry_date: null,
    current_date: null,
    diff_date: null,
    survey_flag: false,
    badge_flag: false,
    hostname: window.location.hostname,
  }),
  computed: {
    isHealthcheckUser() {
      return localStorage.getItem('USER_TYPE') === 'HEALTHCHECK';
    },
    isComplianceDomain() {
      const hostname = window.location.hostname;
      return hostname.includes('compliance') || hostname.includes('tectalik');
    },
    listBackgroundClass() {
      const hostname = window.location.hostname;
      if (hostname.includes('myboardpage_none')) {
        return 'compliance-background';
      } else if (hostname.includes('compliance') || hostname.includes('tectalik')) {
        return 'compliance-background';
      }
      return 'compliance-background';  // Default empty string
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleMobile);
    this.handleMobile();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleMobile);
  },
  methods: {
    refresh_token() {
      window.axios = require("axios");
      axios
        .post("/update_refresh_token/" + this.old_token)
        .then((response) => {
          localStorage.removeItem("TOKEN");
          localStorage.setItem("TOKEN", response.data.new_token);
          this.update_user_data();
        })
        .catch((err) => { });
    },
    getDomainColor() {
      const currentDomain = window.location.hostname;

      if (currentDomain.includes('compliance') || currentDomain.includes('tectalik')) {
        return 'orange';
      } else if (currentDomain.includes('myboardpage_none')) {
        return 'black';
      } else {
        return 'orange';
      }
    },
    update_user_data() {
      let prefix = "cmp_" + this.domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;
      const user_dataset = {
        user_dataset: {
          logged_date: moment(),
          expiry_date: moment().add(7, "days"),
        },
      };
      this.$api
        .put(
          "/update_user_logged_data/" + this.user_id + "/" + prefix,
          user_dataset
        )
        .then((response) => {
          let expiry_date = moment().add(7, "days").format("YYYY-MM-DD");
          localStorage.removeItem("expiry_date");
          localStorage.setItem("expiry_date", expiry_date);
          const name = localStorage.getItem("expiry_date");
          this.badge_flag = false;
        })
        .catch((error) => {
          console.log(error, "error");
        });
    },
    async clearStorage() {
      await invalidateTokenOnLogout();
      localStorage.removeItem("ENTITY_ID");
      localStorage.removeItem("TOKEN");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
    open_ticket() {
      this.dialog = false;
      this.$router.push("ticket");
    },
    open_checklist() {
      this.dialog = false;
      this.$router.push("MainChecklist");
    },
    open_survey() {
      this.dialog = false;
      this.$router.push("survey");
    },
    open_visit() {
      this.dialog = false;
      this.$router.push("/visits/landing");
    },
    open_walkins() {
      this.dialog = false;
      this.$router.push("/walkin/landing");
    },
    incentive_report() {
      this.dialog = false;
      this.$router.push("incentive_reports");
    },
    actual_report() {
      this.dialog = false;
      this.$router.push("actual_reports");
    },
    survey_report() {
      this.dialog = false;
      this.$router.push("survey_reports");
    },
    visit_report() {
      this.dialog = false;
      this.$router.push("visitReport");
    },
    walkins_report() {
      this.dialog = false;
      this.$router.push("/walkins/reports");
    },
    ticket_report() {
      this.dialog = false;
      this.$router.push("tickets_report");
    },
    checklist_report() {
      this.dialog = false;
      this.$router.push("showlist_all_report");
    },
    addsurvey() {
      this.dialog = false;
      this.$router.push("/survey/add");
    },
    addgoals() {
      this.dialog = false;
      this.$router.push({ path: "business_plan", query: { flag: "add" } });
    },
    addwalkins() {
      this.dialog = false;
      this.$router.push({ path: "/walkin/landing", query: { flag: "add" } });
    },
    planvisit() {
      this.dialog = false;
      this.$router.push({
        path: "/visits/landing",
        query: { flag: "planadd" },
      });
    },
    logvisit() {
      this.dialog = false;
      this.$router.push({ path: "/visits/landing", query: { flag: "add" } });
    },
    mainchecklist() {
      this.dialog = false;
      this.$router.push({ path: "MainChecklist", query: { flag: "added" } });
    },
    addkpi(flag) {
      this.dialog = false;
      this.$router.push("kpi_addition_tenant");
    },
    close_ticket() {
      this.dialog = false;
      this.$router.push("/ticket/add");
    },
    addService() {
      this.dialog = false;
      this.$router.push("/service/add");
    },
    addServiceCategory() {
      this.dialog = false;
      this.$router.push("/servicecategory/add");
    },
    add_employee() {
      this.dialog = false;
      this.$router.push("/employee_mstr/add");
    },
    getentityname(name) {
      localStorage.setItem("entity_name", name);
    },
    checkproductvalue(item) {
      var product_list = localStorage.getItem("tectalik_product_list");
      var domain = localStorage.getItem("domain");

      let module_rights_dataset = JSON.parse(
        localStorage.getItem("MODULE_RIGHTS_DATASET")
      );
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let common_screen_right_dataset = JSON.parse(
        localStorage.getItem("COMMON_SCREEN_RIGHT_DATASET")
      );

      let flags_module = 0;
      let flags_screen = 0;
      var flags = 0;
      var product_code = item.product_code;

      let module_codeflag = [];
      let screen_codeflag = [];
      if (item.module_codeflag) {
        module_codeflag = item.module_codeflag;
      }
      if (item.screen_codeflag) {
        screen_codeflag = item.screen_codeflag;
      }

      let orolist = ["Customer_Target", "Customer_Report", "Dashboard"];
      if (!["admin", "devadmin"].includes(domain)) {
        if (
          orolist.includes(item.name) &&
          domain != "oro" &&
          domain != "align"
        ) {
          return false;
        }

        if (item.isnonadmintoshow) {
          if (process.env.NODE_ENV === "production") {
            if (item.isproductiontohide) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          if (!item.iscommontoshow) {
            if (process.env.NODE_ENV === "production") {
              if (item.isproductiontohide) {
                return false;
              }
            }
            if (
              product_list != null &&
              product_list != "" &&
              product_list != undefined &&
              product_list.length != 0
            ) {
              product_list = product_list.split(",");
              if (
                product_code != null &&
                product_code != "" &&
                product_code != undefined &&
                product_code.length != 0
              ) {
                let idex = product_list.filter(function (item) {
                  return product_code.indexOf(item) !== -1;
                });
                if (idex.length !== 0) {
                  flags++;
                }
              }
            }
            if (
              module_rights_dataset != null &&
              module_rights_dataset != "" &&
              module_rights_dataset != undefined &&
              module_rights_dataset.length != 0
            ) {
              var filteredmoudule = module_rights_dataset.filter(function (
                item
              ) {
                return module_codeflag.indexOf(item.module_code) !== -1;
              });
              for (var i = 0; i < filteredmoudule.length; i++) {
                if (filteredmoudule[i].active) {
                  flags_module++;
                  break;
                }
              }
            }
            if (
              screen_right_dataset != null &&
              screen_right_dataset != "" &&
              screen_right_dataset != undefined &&
              screen_right_dataset.length != 0
            ) {
              var filteredScreen = screen_right_dataset.filter(function (item) {
                return screen_codeflag.indexOf(item.screen_code) !== -1;
              });
              for (var i = 0; i < filteredScreen.length; i++) {
                if (filteredScreen[i].landing) {
                  flags_screen++;
                  break;
                }
              }
            }
            //
            if (flags > 0 && flags_module > 0 && flags_screen > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      } else {
        if (!item.iscommontoshow) {
          let flags_screen = 0;
          if (
            common_screen_right_dataset != null &&
            common_screen_right_dataset != "" &&
            common_screen_right_dataset != undefined &&
            common_screen_right_dataset.length != 0
          ) {
            var filteredScreen = common_screen_right_dataset.filter(function (
              item
            ) {
              return screen_codeflag.indexOf(item.screen_code) !== -1;
            });
            for (var i = 0; i < filteredScreen.length; i++) {
              if (filteredScreen[i].landing) {
                flags_screen++;
                break;
              }
            }
          }

          if (flags_screen > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    handleMobile() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 576) {
        this.show_hide_mob_btn = 2;
        this.full_or_modal = 1;
      } else {
        this.show_hide_mob_btn = 1;
        this.full_or_modal = 0;
      }
    },
    backupstick() {
      this.$router.push("/fms_home");
    },
    backups() {
      var product_get = localStorage.getItem("tectalik_product_list");
      let product_list = [];
      if (
        product_get != null &&
        product_get != "" &&
        product_get != undefined &&
        product_get.length != 0
      ) {
        product_list = product_get.split(",");
      }
      if (product_list.includes("TECTALIK_FMS")) {
        this.$router.push("/welcome_page");
      } else {
        this.$router.push("/tasks_detail_mobile");
      }
    },
    backups1() {
      this.$router.push("/team_list");
    },
    backups2() {
      this.$router.push("/quick_links");
    },
    backups3() {
      this.$router.push("/score_list");
    },
    backups4() {
      this.$router.push("/kpi_bots");
    },
    backups5() {
      this.$router.push("/set_strategy");
    },
    UpdateProfile() {
      this.$router.push({ path: "/My_profile" });
    },
    router_pusher(path = "") {
      if (this.$route.path != path) {
        this.$router.push({ path: path });
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 576) {
        this.iflag = 1;
      } else {
        this.iflag = 0;
      }
    },
    profile() {
      this.$router.push("#ProfilePMS");
    },
    openmenu() {
      this.drawer = !this.drawer;
      this.showimage = !this.showimage;
    },
    login() {
      if (isNaN(this.entity_id) == true || this.entity_id == null) {
        return;
      }
      localStorage.setItem("ENTITY_ID", this.entity_id);
      var url_string = "";
      var url_break = window.location.pathname.split("/");
      url_break = url_break[1];
      if (
        url_break == "checklist_Template_page" ||
        url_break == "kpi_additions" ||
        url_break == "templatelibrary" ||
        url_break == "appraisal_add"
      ) {
        url_string = "tapi/";
      }
      axios
        .get(url_string + "get_email_by_entity", {
          params: {
            email: localStorage.getItem("USER_EMAIL"),
            entity_id: this.entity_id,
            user_id: this.user_id,
          },
        })
        .then((response) => {
          return;
        });
      this.overlay_load = true;
    },
    set_local_storage(module_dataset = [], screen_dataset = []) {
      localStorage.setItem(
        "MODULE_RIGHTS_DATASET",
        JSON.stringify(module_dataset)
      );
      for (let i = 0; i < screen_dataset.length; i++) {
        screen_dataset[i]["hide_all"] = false;
        screen_dataset[i]["module_name"] = false;
        for (let j = 0; j < module_dataset.length; j++) {
          if (screen_dataset[i].modules_rights_id == module_dataset[j].id) {
            screen_dataset[i]["hide_all"] = module_dataset[j].active;
            screen_dataset[i]["module_name"] = module_dataset[j].module_name;
          }
        }
      }
      localStorage.setItem(
        "SCREEN_RIGHT_DATASET",
        JSON.stringify(screen_dataset)
      );
    },
    logout() {
      // Check if user has SCN_ANALYTICS permission
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let hasAnalyticsAccess = false;

      if (
        screen_right_dataset != null &&
        screen_right_dataset != "" &&
        screen_right_dataset != undefined &&
        screen_right_dataset.length != 0
      ) {
        // Filter screen rights for SCN_ANALYTICS
        var filteredScreen = screen_right_dataset.filter(function (item) {
          return item.screen_code === "SCN_ANALYTICS";
        });

        // Check if user has landing permission for SCN_ANALYTICS
        for (var i = 0; i < filteredScreen.length; i++) {
          if (filteredScreen[i].landing) {
            hasAnalyticsAccess = true;
            break;
          }
        }
      }

      // Only call analytics API if user has SCN_ANALYTICS permission
      if (hasAnalyticsAccess) {
        const token_update = {
          token: null,
          email: this.logged_user_Email,
          product_code: "PRMS",
          sub_domain: this.domain,
        };
        axios
          .post("analytics_token_update", token_update)
          .then(() => {})
          .catch(() => {});
      }

      this.clearStorage();
    },
    switch_entity() {
      this.switch_dialog = true;
      let data = JSON.parse(localStorage.getItem("entitydata"));
      this.entity_dataset = [];
      for (let i = 0; i < data.length; i++) {
        {
          this.entity_dataset.push({
            id: data[i].id,
            name: data[i].name,
          });
        }
      }
    },
    screenrights_fn(code, flag, to, item) {
      var features_list = localStorage.getItem("features_list");
      var domain = localStorage.getItem("domain");
      var flags = 0;

      if (!["admin", "devadmin"].includes(domain)) {
        if (
          features_list != null &&
          features_list != "" &&
          features_list != undefined &&
          features_list.length != 0
        ) {
          features_list = features_list.split(",");
          for (var i = 0; i < features_list.length; i++) {
            if (code == features_list[i]) {
              flags++;
              break;
            }
          }
        }

        if (to == "/login" || to == "/show_list") {
          return 1;
        } else {
          if (flags > 0) {
            return 1;
          } else {
            return 0;
          }
        }
      } else {
        if (item.iscommontoshow) {
          return 1;
        }
        return 0;
      }
    },
    app_version() {
      this.currentUrl = window.location.href;
      const urlParts = this.currentUrl.split("/");
      let rout = urlParts[3];

      const exemptRoutes = [
        "health_check_answer", "finance_health_questions", "health_check_dashboard",
        "health_check_dashboard_view", "health_check_home_screen",
        "completion_screen_health_check", "payment-required", "login",
      ];

      // Only alert if resultat exists AND is a different version (not on first login)
      if (this.resultat && this.applicationVersion != this.resultat) {
        if (!exemptRoutes.includes(rout)) {
          alert("New version is out! Please logout and re-login to continue");
        }
      }
      // Always sync resultat to current version silently
      localStorage.setItem("resultat", this.applicationVersion);
      this.resultat = this.applicationVersion;
    },
  },
};
</script>